<template>
  <div class="rental-company-list">
    <heading title="Rental Companies" tag="rental-company-list-title">
      <b-button v-if="isAdmin"
                variant="primary"
                :to="{ name: 'rentalCompanyCreate'}">
        Create Rental Company
        <b-icon-plus-square />
      </b-button>
    </heading>
    <data-table ref="dataTable"
                persist-name="rental-company-filter"
                :show-filters="true"
                :show-pager="true"
                :get-items="getEntries"
                v-model="filters"
                :fields="fields">
      <template v-slot:customField="slotProps">
        <div v-if="slotProps.row.field.key === 'actions'"
             class="action-buttons d-flex">
          <b-button size="sm"
                    variant="secondary"
                    class="mr-2"
                    :to="{ name: 'rentalCompanyView', params: { rentalCompanyId: slotProps.row.item.id } }">
            <b-icon-eye/>
          </b-button>
          <template v-if="isAdmin">
            <b-button size="sm"
                      variant="secondary"
                      class="mr-2"
                      :to="{ name: 'rentalCompanyEdit', params: { rentalCompanyId: slotProps.row.item.id } }">
              <b-icon-pencil-fill />
            </b-button>
            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                    v-if="slotProps.row.item.status === 'UNAPPROVED'"
                    v-on:click="approve(slotProps.row.item)">
              Approve
            </button>
            <button class="btn btn-danger btn-sm mr-2"
                    v-if="slotProps.row.item.status === 'APPROVED'"
                    v-on:click="unapprove(slotProps.row.item)">
              Unapprove
            </button>
          </template>
        </div>
        <div v-else-if="slotProps.row.field.key === 'address'">
          {{ formatAddress(slotProps.row.item) }}
        </div>
        <div v-else-if="slotProps.row.field.key === 'status'">
          <b-badge v-if="slotProps.row.item.status === 'APPROVED'"
                   variant="primary">
            Approved
          </b-badge>
          <b-badge v-if="slotProps.row.item.status === 'UNAPPROVED'"
                   variant="danger">
            Unapproved
          </b-badge>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import RentalCompany from "@/models/RentalCompany";

export default {
  name: "RentalCompanyList",
  data () {
    return {
      notetext: "",
      modelItem: null,
      filters: {}
    };
  },
  computed: {
    isAdmin () {
      return this.$user.isAdmin() || this.$user.isSuperAdmin()
    },
    fields() {
      return [
        { key: "name", sortable: true, label: "Name" },
        { key: "address", sortable: false, label: "Address" },
        ...(this.isAdmin
              ? [
                  { key: "status", sortable: false, label: "Status" },
                ]
              : []),
        { key: "actions", sortable: false, label: "Actions" }
      ]
    },
    defaultFilters() {
      return {
        name: {
          field: "name",
          label: "Name",
          type: "string"
        },
        address: {
          field: "address",
          label: "Address",
          type: "string"
        },
        ...(this.isAdmin
            ? {
                status: {
                  field: "status",
                  label: "Status",
                  type: "select",
                  options: [
                    { value: "*", text: "All" },
                    { value: "APPROVED", text: "Approved" },
                    { value: "UNAPPROVED", text: "Unapproved" }
                  ]
                }
              }
            : {})
        }
    },
  },
  methods: {
    getEntries (listParams) {
      return this.$api.getItems(this, "rental-company", this.filters, listParams);
    },
    approve (item) {
      item.status = "APPROVED";
      this.$api.updateItem(this, "rental-company", item).then(response => {
        this.$refs.dataTable.refresh();
      });
    },
    unapprove (item) {
      item.status = "UNAPPROVED";
      this.$api.updateItem(this, "rental-company", item).then(response => {
        this.$refs.dataTable.refresh();
      });
    },
    formatAddress (item) {
      return RentalCompany.formatAddress(item);
    },
  },
  mounted () {
    this.filters = this.defaultFilters;
  }
};
</script>

<style scoped></style>
